import { Link } from 'react-router-dom'
import { motion } from 'motion/react'
import { ArrowRight } from 'lucide-react'
import { AnimatedCard, CardHeader, CardTitle, CardDescription, CardContent, Badge } from '@/components/ui'
import { services } from '@/data/services'

export function Services() {
  return (
    <section className="section-padding relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary-600/30 to-transparent" />
      
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <Badge className="mb-4">Our Solutions</Badge>
          <h2 className="text-display-md md:text-display-lg font-heading font-bold text-white mb-4">
            Empower Your Enterprise
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Comprehensive technology solutions designed to drive efficiency, productivity, and growth for your business.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link to={service.href}>
                <AnimatedCard className="h-full group">
                  <CardHeader>
                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-accent-500/20 to-electric-500/20 flex items-center justify-center mb-4 group-hover:from-accent-500/30 group-hover:to-electric-500/30 transition-colors">
                      <service.icon className="w-7 h-7 text-accent-400" />
                    </div>
                    <CardTitle className="group-hover:text-accent-400 transition-colors">
                      {service.shortTitle}
                    </CardTitle>
                    <CardDescription className="text-base">
                      {service.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center gap-2 text-accent-400 text-sm font-medium group-hover:gap-3 transition-all">
                      Learn More
                      <ArrowRight className="w-4 h-4" />
                    </div>
                  </CardContent>
                </AnimatedCard>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}


